<!-- ─── Header card ─────────────────────────────────────────────────────────── -->
<div class="card header">
  <div class="description">
    <h4>Scripts</h4>
    <p>
      Scripts run custom JavaScript when system events occur - such as scheduling
      follow-ups, sending SMS messages, or tagging leads based on complex logic.
    </p>

    <h5>How scripts work</h5>
    <p>
      Register listeners with <code>hook(triggerName, callback)</code>.
      Inside a callback, use <code>schedule(trigger, delay, data, ctx)</code>
      to queue future work, or call helpers like <code>sendSMS()</code>,
      <code>sendEmail()</code>, and <code>addTag()</code> directly.
    </p>
    <p>
      Scripts can be written inline or hosted on
      <strong>functions.moveright.app</strong> (TypeScript supported).
    </p>
  </div>
  <div class="buttons">
    <button
      type="button"
      pButton
      *hasPermission="['scripts.create']"
      icon="pi pi-plus"
      label="Add Script"
      (click)="openCreate()"
    ></button>
  </div>
</div>

<!-- ─── Script list ────────────────────────────────────────────────────────── -->
<div class="card scripts-card">
  <app-scripts #appScripts></app-scripts>
</div>